/**
 * The optimistic row carries the `_meta` the client wrote; the synced row
 * carries `client_meta`, the name the server stores it under.
 */
export const getSessionPartClientMeta = (part: {
  client_meta?: { [key: string]: unknown } | null;
}): Record<string, unknown> | undefined => {
  const optimisticMeta = (part as { _meta?: Record<string, unknown> })._meta;
  return optimisticMeta ?? part.client_meta ?? undefined;
};
